import React from "react";
import { Outlet } from "react-router-dom";

import SideBar from "./sideBar";
import TopBar from "./topBar";
import Navbar from "./Navbar";
import Footer from "./layout/Footer";

const MainLayout = () => {
  return (
    <>
      <div className="w-full">
        <div className="grid grid-cols-12">
          {/* TopBar solo mobile */}
          <div className="col-span-12 lg:hidden">
            <TopBar />
          </div>

          {/* Sidebar desktop */}
          <div className="hidden lg:block md:col-span-3 lg:col-span-3 xl:col-span-2">
            <SideBar />
          </div>

          {/* Contenido */}
          <div className="col-span-12 md:col-span-12 lg:col-span-9 xl:col-span-10 mx-4">
            <div className="bodyPage">
              <div className="NavbarTop">
                <Navbar />
              </div>

              <Outlet />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default MainLayout;
